import { render, staticRenderFns } from "./EditQualificationDialog.vue?vue&type=template&id=5e94a19f&scoped=true"
import script from "./EditQualificationDialog.vue?vue&type=script&lang=ts"
export * from "./EditQualificationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e94a19f",
  null
  
)

export default component.exports